import { EventParticipant } from "./event-participant";

export class Event {
    id: number;
    date: Date;
    title: string;
    description: string;
    location: string;
    locationBranch?: string;
    createdBy: string;
    wasCancelled: boolean;
    participants: EventParticipant[];

    constructor(event: Event) {
        for (const key in event) {
            if (event.hasOwnProperty(key)) {
                this[key] = event[key];
            }
        }
    }
}